import {
  FaArrowLeft,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import React, { useState } from "react";
import axios from "axios";
import Footer from "./Footer";
import Header from "./header";
import { Helmet } from "react-helmet";

const styles = {
  page: {
    padding: "40px",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "1.2fr 1fr",
    gap: "40px",
    maxWidth: "1200px",
    margin: "auto",
    marginTop: "50px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
  },
  textarea: {
    width: "100%",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    resize: "none",
    height: "120px",
  },
  button: {
    background: "#D60000",
    color: "#fff",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  rightCard: {
    padding: "20px",
    borderRadius: "12px",
    background: "#F8FAFC",
  },
  officeImg: {
    width: "100%",
    borderRadius: "12px",
    marginBottom: "20px",
  },
  infoItem: {
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
    alignItems: "flex-start",
  },
  error: {
    color: "red",
    fontSize: "12px",
    marginBottom: "10px",
  },
};

const ContactUs = ({ onBack }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    product: "",
    kw: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let newErrors = {};

    const name = form.name.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    const message = form.message.trim();

    if (!name) newErrors.name = "Name is required";
    else if (name.length < 3) newErrors.name = "Minimum 3 characters";
    else if (name.length > 50) newErrors.name = "Max 50 characters";

    if (!email) newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(email)) newErrors.email = "Invalid email";

    if (!phone) newErrors.phone = "Phone is required";
    else if (!/^[0-9]{10}$/.test(phone))
      newErrors.phone = "Enter valid 10-digit number";

    if (!form.product) newErrors.product = "Select product";
    if (!form.kw) newErrors.kw = "Select kW";

    if (message && message.length > 300)
      newErrors.message = "Max 300 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/contactus`,
        {
          name: form.name.trim(),
          email: form.email.trim(),
          phone: form.phone.trim(),
          product: form.product,
          kw: form.kw,
          message: form.message.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      alert("Submitted Successfully ✅");

      setForm({
        name: "",
        email: "",
        phone: "",
        product: "",
        kw: "",
        message: "",
      });
      setErrors({});
    } catch (err) {
      console.error("API Error:", err.response || err);
      alert("Error submitting form ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact US | CGRMART</title>

        <meta
          name="description"
          content="Contact Tucker Motors for EV chargers, DC fast chargers, AC chargers, and installation support. Get the best EV charging solutions in India."
        />

        <meta
          name="keywords"
          content="EV charger contact India, DC fast charger enquiry, AC charger supplier, EV charging station support, Tucker Motors contact"
        />
        
        <meta name="author" content="Tucker Motors" />

        {/* Open Graph */}
        <meta property="og:title" content="Contact Tucker Motors" />
        <meta
          property="og:description"
          content="Get in touch for EV charging solutions and installation support."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cgrmart.com/contactus" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Tucker Motors" />
        <meta
          name="twitter:description"
          content="Reach out for EV charger solutions across India."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://cgrmart.com/contactus" />
      </Helmet>

      <Header />

      <div style={styles.page}>
        <div style={styles.container}>
          {/* LEFT FORM */}
          <div>
            <h2>Contact Us</h2>

            <form onSubmit={handleSubmit}>
              <input
                style={styles.input}
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
              />
              {errors.name && <div style={styles.error}>{errors.name}</div>}

              <input
                style={styles.input}
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
              />
              {errors.email && <div style={styles.error}>{errors.email}</div>}

              <input
                style={styles.input}
                name="phone"
                placeholder="Your Phone"
                value={form.phone}
                onChange={handleChange}
              />
              {errors.phone && <div style={styles.error}>{errors.phone}</div>}

              <select
                style={styles.input}
                name="product"
                value={form.product}
                onChange={handleChange}
              >
                <option value="">Select Product</option>
                <option>DC Fast Charger Single Gun</option>
                <option>DC Fast Charger Dual Gun</option>
                <option>TYPE 2 AC Charger</option>
              </select>
              {errors.product && (
                <div style={styles.error}>{errors.product}</div>
              )}

              <select
                style={styles.input}
                name="kw"
                value={form.kw}
                onChange={handleChange}
              >
                <option value="">Select kW</option>
                <option>3.3kW</option>
                <option>7.4kW</option>
                <option>11kW</option>
              </select>
              {errors.kw && <div style={styles.error}>{errors.kw}</div>}

              <textarea
                style={styles.textarea}
                name="message"
                placeholder="Your Message"
                value={form.message}
                onChange={handleChange}
              />
              {errors.message && (
                <div style={styles.error}>{errors.message}</div>
              )}

              {/* Fake captcha */}
              <div
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  borderRadius: "6px",
                  marginBottom: "15px",
                }}
              >
                ✅ I'm not a robot
              </div>

              <button type="submit" style={styles.button} disabled={loading}>
                {loading ? "Submitting..." : "Send your requirement"}
              </button>
            </form>
          </div>

          {/* RIGHT SIDE */}
          <div style={styles.rightCard}>
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab"
              alt="office"
              style={styles.officeImg}
            />
            <div style={styles.infoItem}>
              <FaEnvelope color="red" />
              <div>
                <strong>Email</strong>
                <p>info@tuckermotors.com</p>
                <p>support@tuckermotors.com</p>
              </div>
            </div>

            <div style={styles.infoItem}>
              <FaPhoneAlt color="red" />
              <div>
                <strong>Call Us</strong>
                <p>+918220057752</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactUs;
